import { createFileRoute } from "@tanstack/react-router";
import { AutoMessagesPage } from "../components/auto-messages/AutoMessagesPage";

export const Route = createFileRoute("/_auth/_messaging/auto-messages")({
  staticData: { titleKey: "nav.messaging", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 7 },
  component: AutoMessagesPage,
});
